export default {
    modalGenerateImageVariations: {
        imageAIHeader: 'Crea una imagen usando inteligencia artificial',
        requestFailed: 'Solicitud fallida',
        describeYourImage: 'Describe tu imagen',
        numberOfVariations: 'Número de variantes',
        chooseStyle: 'Elige tu estilo de imagen',
        descriptionPlaceholder: '(eg) Un campo de flores de mostaza en un día de verano con robles',
        clear: 'Claro',
        generate: 'Generar',
        seeAll: 'Ver todo',
        tryAnExample: 'Prueba un ejemplo',
        tryAnother: 'Intenta otra',
    },
};
